const getSession = item => JSON.parse(sessionStorage.getItem(item) || '{}');

export default getSession;
